import React from 'react';
import PropTypes from 'prop-types';

import Heading from '../../fields/Heading';
import Body from '../../fields/Body';

const ParagraphText = props => {
    // Insert base url into any Image tags.
    const text = props.body.value.replace(
        'src="/',
        `src="${process.env.GATSBY_BASE_URL}/`
    );
    return (
        <section className="section text">
            {props.title && (
                <Heading classes="text__header">{props.title}</Heading>
            )}
            <Body classes="text__body" files={props.files}>
                {text}
            </Body>
        </section>
    );
};

ParagraphText.propTypes = {
    body: PropTypes.shape({
        value: PropTypes.string,
    }),
    title: PropTypes.string,
    files: PropTypes.array.isRequired,
};

export default ParagraphText;
